import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import styled from "styled-components";
import OrderController from "../controller/OrderController";
import AsyncLocalStorage from "../util/AsyncLocalStorage";
import { useToast } from "../controller/ToastController";
import UserController from "../controller/UserController";

const PaymentPassword = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const orderData = location.state?.orderData;
  const passwordType = location.state?.passwordType;
  const loginAccount = location.state?.loginAccount;

  const showToast = useToast();

  const [keypad, setKeypad] = useState<string[][]>([]);
  const [password, setPassword] = useState<string[]>([]);

  const keypadNumber = [
    ["1", "2", "3"],
    ["4", "5", "6"],
    ["7", "8", "9"],
    ["0"],
  ];
  const deleteButton = ["삭제"];
  const allReset = ["전체삭제"];
  const numbersArray = keypadNumber
    .flat()
    .filter((item) => item !== "전체삭제");

  for (let i = numbersArray.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [numbersArray[i], numbersArray[j]] = [numbersArray[j], numbersArray[i]];
  }
  const keypadButtons = [
    numbersArray.slice(0, 3),
    numbersArray.slice(3, 6),
    numbersArray.slice(6, 9),
    [allReset[0], numbersArray[9], deleteButton[0]],
  ];

  // API 호출
  const orderCart = async () => {
    try {
      if (orderData) {
        const oParams = orderData;
        const oRes = await OrderController.newOrder(oParams);

        if (oRes && oRes.data && oRes.data.ok) {
          if (oRes.data.ok) {
            console.log("newOrder", oRes.data);
            AsyncLocalStorage.removeItem("cart");
            AsyncLocalStorage.removeItem("reorder");
            navigate("/order/complete", {
              state: { orderData },
              replace: true,
            });
          } else {
            showToast(`${oRes.data.result_msg}`, "error");
            navigate("/home", { replace: true });
          }
        }
      }
    } catch (err) {
      console.log("err---->", err);
    }
  };

  const PasswordCheck = () => {
    if (orderData) {
      orderCart();
    } else if (passwordType) {
      if (passwordType === "loginCheck") {
        navigate("/home");
      } else if (passwordType === "paymentCheck") {
      } else if (passwordType === "login") {
        if (loginAccount) {
          //console.log('loginAccount', loginAccount);
          checkLoginPassword(loginAccount);
        }
      } else if (passwordType === "edit") {
        updateUserLoginPassword();
      }
    }
  };

  const updateUserLoginPassword = async () => {
    let oUserData = await AsyncLocalStorage.getItem("accountSetting");
    if (oUserData) {
      let oRes: any = await UserController.setLoginPassword({
        use_password: true,
        car_uuid: oUserData.car_uuid,
        login_password: password.join(""),
      });
      if (oRes && oRes.data && oRes.data.success === true) {
        oUserData.use_password = 1;
        await AsyncLocalStorage.setItem(
          "accountSetting",
          JSON.stringify(oUserData)
        );
        navigate("/setting");
      }
    }
  };

  const checkLoginPassword = async (sLoginAccount: string) => {
    if (sLoginAccount) {
      try {
        /*
        let oLoginAccount = JSON.parse(sLoginAccount);
        if (oLoginAccount) {
          let oRes = await UserController.checkLoginPassword({
            "car_uuid": oLoginAccount.car_uuid,
            "use_password": oLoginAccount.use_password,
            "login_password": password.join("")
          }, oLoginAccount.token, oLoginAccount.refresh_token);
          if (oRes && oRes.data) {
            if (oRes.data.success) {
              AsyncLocalStorage.setItem("accountSetting", JSON.stringify(oRes.data.user));
              await AsyncLocalStorage.setItem("userToken", (oRes.data.user.token).toString());
              await AsyncLocalStorage.setItem("userRefreshToken", (oRes.data.user.refresh_token).toString());
              navigate("/home");
            } else {
              showToast("비밀번호를 다시 확인하세요.", "error");
            }
          } else {
            navigate("/home");
          }
        }
        */
        navigate("/home");
      } catch (error) {
        navigate("/home");
      }
    }
  };

  const handleClick = (value: string) => {
    if (value === "삭제") {
      setPassword((prevValues) => prevValues.slice(0, -1));
    } else if (value === "전체삭제") {
      setPassword([]);
    } else if (password.length < 4) {
      setPassword((prevValues) => [...prevValues, value]);
    }
  };

  useEffect(() => {
    setKeypad(keypadButtons);
  }, []);

  useEffect(() => {
    if (password.length === 4) {
      // 입력완료시
      PasswordCheck();
    }
  }, [password]);

  return (
    <Style>
      <div className="wrapper">
        <h1>
          {orderData
            ? "결제 비밀번호를 입력해주세요"
            : "비밀번호 4자리를 입력해주세요"}
        </h1>
        <div className="circleWrap">
          {password.map((index) => (
            <div key={index} className="circle filled"></div>
          ))}
          {[...Array(4 - password.length)].map((_, index) => (
            <div
              key={index + password.length + new Date().getMilliseconds()}
              className="circle"
            />
          ))}
        </div>
        <div className="numberPadWrapper">
          {keypad.map((row, rowIndex) => (
            <div className="row" key={rowIndex}>
              {row.map((button, buttonIndex) => (
                <button
                  className="numberSource"
                  key={buttonIndex}
                  onClick={() => handleClick(button)}
                >
                  {button === "삭제" ? (
                    <img
                      src={`${process.env.PUBLIC_URL}/svg/ic_backspace.svg`}
                      alt="delete"
                    />
                  ) : (
                    <h2>{button}</h2>
                  )}
                </button>
              ))}
            </div>
          ))}
        </div>
      </div>
    </Style>
  );
};

export default PaymentPassword;

const Style = styled.div`
  .wrapper {
    width: 100vw;
    height: 100vh;
    padding: 40px 25%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
  h1 {
    font-size: 32px;
    font-weight: 500;
    text-align: center;
  }
  h2 {
    font-size: 30px;
    font-weight: 600;
  }
  img {
    width: 46px;
    height: 46px;
  }

  .row {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .numberSource {
    border: 1px solid #6490e8;
    border-radius: 10px;
    width: 160px;
    height: 100px;
    margin: 8px 10px;
    padding: 0;
  }
  .circleWrap {
    width: 50%;
    padding: 4% 0;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 3%;
  }
  .circle {
    border: 1px solid #000;
    width: 24px;
    height: 24px;
    border-radius: 100px;
    background: #555;
  }
  .circle.filled {
    background: #6490e8;
  }

  @media (max-width: 1400px) {
    .wrapper {
      padding: 40px 8%;
    }
    h1 {
      font-size: 2.5rem;
    }
    h2 {
      font-size: 2rem;
    }
    .numberSource {
      width: 180px;
      height: 110px;
    }
    .circleWrap {
      padding: 10% 0;
      gap: 8%;
    }
    .circle {
      width: 28px;
      height: 28px;
    }
  }
`;
